
import { IonContent,RefresherEventDetail,IonList, IonPage, IonRefresher, IonRefresherContent } from "@ionic/react";
import { useCommonChannels } from "hooks";

import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import { useStore } from "store";
import ChatroomItem from "./components/chatroom-item";
import { DropDownSVG, PeopleSVG } from "./svg";

const NewChatRoom = () => {
    const { pathname } = useLocation();
    const { commonChatRoomMessages } = useStore()
    const { currentChannel, onChooseChannel, channelPeopleCount } = useCommonChannels()
    const chatListRef = useRef<HTMLUListElement>(null)
    const [activeChatId, setActiveChatId] = useState<string | undefined>()
    const [messagesList, setMessagesList] = useState<any[]>([])

    const handleChatClick = (id: string) => {
        setActiveChatId(activeChatId === id ? undefined : id)
    }

    const pageSize = 10;
    const pageNum = useRef(0);

    function paginate(array:Array<any>, pageSize: number, pageNumber: number) {
        let data = array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
        data.sort((a, b) => new Date(a.message_time).getTime() - new Date(b.message_time).getTime())
        return data;
    }

    useEffect(() => {
        console.log("commonChatRoomMessages",commonChatRoomMessages)
        console.log(pageNum.current)
        pageNum.current = 1
        const currentPageItems = paginate(commonChatRoomMessages, pageSize, pageNum.current);
        setMessagesList(currentPageItems);
    },[commonChatRoomMessages])

    useEffect(() => {
        const timer = setTimeout(() => {
            if (pathname !== '/chatroom' || !chatListRef || !chatListRef.current) return;
            chatListRef.current.scrollIntoView({ block: 'end', behavior: 'auto' })
        }, 500)
        return () => clearTimeout(timer)
    }, [pathname, chatListRef]);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (currentChannel && chatListRef && chatListRef.current) {
                chatListRef.current.scrollIntoView({ block: 'end', behavior: 'auto' })
            }
        }, 500)
        return () => clearTimeout(timer)
    }, [currentChannel])

    const handleLoadMore = (event: CustomEvent<RefresherEventDetail>) => {
        pageNum.current ++
        const currentPageItems = paginate(commonChatRoomMessages, pageSize, pageNum.current);
        setMessagesList([...currentPageItems,...messagesList]);
        setTimeout(() => event.detail.complete(), 500);
    }
    return (
        <IonPage>
            <div className="chatroom__header">
                <div onClick={onChooseChannel} className="chatroom__header--dropdown">
                    <span>{currentChannel?.room_name}</span>
                    <DropDownSVG />
                </div>
                <div className="chatroom__header--people">
                    <PeopleSVG />
                    <span>{channelPeopleCount}</span>
                </div>
            </div>
            <IonContent>
                <IonRefresher slot="fixed" onIonRefresh={handleLoadMore}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                <div className="chatroom">
                    <div className="chatroom__content">
                        <div className="chatroom__content--list">
                            {/* <IonInfiniteScroll
                                onIonInfinite={(ev) => handleLoadMore(ev)}
                                threshold="100px"
                                position="top"
                            >
                                <IonInfiniteScrollContent ></IonInfiniteScrollContent>
                            </IonInfiniteScroll> */}
                            <IonList>
                            <div style={{minHeight: '64px'}}></div>
                            <ul ref={chatListRef} >
                                {
                                    messagesList.map(chat => (
                                        <ChatroomItem emojiIconList={['👍', '❤️', '✋', '👏', '💰', '🚀']} type="ChatRoom" chat_message={{ message_id: chat.message_id, avatar: chat.avatar_url, message_time: chat.message_time }} ActiveBoxId={activeChatId} onClick={() => handleChatClick(chat.message_id)} key={chat.message_id}>
                                            <div className="public_chat_txt_box">
                                                <img src={chat.avatar_url} alt="avatar" />
                                                <p>
                                                    {chat.text}
                                                </p>
                                            </div>
                                        </ChatroomItem>
                                    )
                                    )
                                }
                            <div style={{minHeight: '84px'}}></div>
                            </ul>
                            </IonList>
                        </div>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    )
}

export default NewChatRoom


